import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import "./Admin.css";
import { Col, Form, Modal, Row } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import AdminSideBar from "./AdminSideBar";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
function AdminUsuarios() {
  const user = useSelector((state) => state.user_auth);
  const [modalAgregar, setModalAgregar] = useState(false);
  const [modalBorrar, setModalBorrar] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);

  const [contador, setContador] = useState(0);
  const [idUser, setIdUser] = useState("");

  let delayInMilliseconds = 500;

  const deleteUser = async () => {
    const deleteURL = process.env.REACT_APP_API_URL + `/admin/users/${idUser}`;
    try {
      const response = await axios({
        method: "DELETE",
        url: deleteURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      if (response.status === 200) {
        toast.info(`${response.data.message}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
        setIdUser("");
      }
    } catch (error) {
      toast.error(`Error : ` + error, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const postUser = async (e) => {
    e.preventDefault();
    const { firstname, lastname, email, username, password, address, phone } = e.target;
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_API_URL + "/admin/users",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          firstName: firstname.value,
          lastName: lastname.value,
          email: email.value,
          userName: username.value,
          password: password.value,
          address: address.value,
          phone: phone.value,
          admin: false,
        },
      });
      console.log(response);
      if (response.status === 200) {
        toast.info(`${response.data.message}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
        setIdUser("");
      }
      /* toast.info(`😀 Usuario ${response.firstName.toUpperCase()} agregado con éxito!`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }); */
    } catch (error) {
      toast.error(
        <div>
          Error al registrarse <br /> Verifique que los datos sean correctos
        </div>,
        {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      console.log("ERROR al registrarse: ", error);
      //setError("Ocurrió un error, verifique que los datos ingresados sean correctos");
    }
  };

  const updateAdmin = async (e) => {
    console.log(idUser);
    e.preventDefault();
    const url = process.env.REACT_APP_API_URL + "/admin/users/" + idUser;
    console.log(url);
    try {
      const response = await axios({
        method: "PATCH",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          admin: isAdmin,
        },
      });
      setIdUser("");
      console.log("Respuesta del servidor : ", response);
      setTimeout(function () {
        setContador(contador + 1);
      }, delayInMilliseconds);
    } catch (error) {
      console.log(error);
    }
  };

  const [modalAdmin, setModalAdmin] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const allUsersURL = process.env.REACT_APP_API_URL + `/admin/users`;

    const fetchUsersData = async () => {
      const usersData = await axios({
        method: "GET",
        url: allUsersURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      setUsers(usersData.data);
    };

    fetchUsersData();
  }, [contador]);

  return (
    <div id="twc-admin">
      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="third">
          <Row className="mt-6 mb-5">
            <Col sm={2} className="d-flex flex-column">
              <AdminSideBar />
              <button
                type="button"
                className="btn btn-success d-flex justify-content-center align-items-center mt-5"
                onClick={() => setModalAgregar(true)}
              >
                Agregar Usuario
              </button>
            </Col>
            <Col sm={10}>
              <Tab.Content>
                <Tab.Pane eventKey="third">
                  <div className="table-responsive shadow p-4 border border-dark rounded admin-table">
                    {users.length !== 0 ? (
                      <table className="table table-light table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Username</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Address</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Admin</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.map((user) => (
                            <tr key={user._id}>
                              <th scope="row">{user.userName}</th>
                              <td>{`${user.firstName} ${user.lastName}`} </td>
                              <td>{user.address}</td>
                              <td>{user.phone}</td>
                              <td>
                                {user.admin ? (
                                  <i className="fas fa-check"></i>
                                ) : (
                                  <i className="fas fa-times"></i>
                                )}
                              </td>
                              <td>
                                <div className="d-flex align-items-center justify-content-center">
                                  <button
                                    type="button"
                                    className="btn btn-secondary btnAdmin d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      setIsAdmin(user.admin);
                                      setModalAdmin(true);
                                      setIdUser(user._id);
                                    }}
                                  >
                                    <i className="fas fa-cogs"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-danger btnAdmin ms-1 d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      setModalBorrar(true);
                                      setIdUser(user._id);
                                    }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="d-flex justify-content-center text-center align-items-center">
                        <Spinner animation="border" role="status"></Spinner>
                        <span className="ms-1">Loading...</span>
                      </div>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>

        {/* MODAL ADMIN */}
        <Modal show={modalAdmin} onHide={() => setModalAdmin(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Dar o revocar privilegios</Modal.Title>
          </Modal.Header>
          <form
            onSubmit={(e) => {
              updateAdmin(e);
              setModalAdmin(false);
            }}
          >
            <Modal.Body>
              <div className="d-flex justify-content-center">
                <Form.Check
                  type={"checkbox"}
                  label="Administrador"
                  defaultChecked={isAdmin}
                  onChange={() => setIsAdmin(!isAdmin)}
                  name="recommended"
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="sumbit"
                className="btn btn-success"
                onClick={() => setModalAdmin(false)}
              >
                Confirmar
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalAdmin(false)}
              >
                Cancelar
              </button>
            </Modal.Footer>
          </form>
        </Modal>
        {/* MODAL BORRAR USER */}
        <Modal show={modalBorrar} onHide={() => setModalBorrar(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>¿Estás seguro de que querés eliminar este usuario?</Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                deleteUser();
                setModalBorrar(false);
              }}
            >
              Borrar
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalBorrar(false)}
            >
              Cancelar
            </button>
          </Modal.Footer>
        </Modal>
        <Modal show={modalAgregar} onHide={() => setModalAgregar(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Agregar producto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form
              id="newProduct"
              onSubmit={(e) => {
                postUser(e);
                setModalAgregar(false);
              }}
            >
              <label htmlFor="inputFirstName" className="fw-bold fs-6  mb-2">
                Nombre
              </label>
              <input
                name="firstname"
                type="text"
                className="form-control"
                placeholder="John"
                id="inputFirstName"
              />
              <label htmlFor="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
                Apellido
              </label>
              <input
                name="lastname"
                type="text"
                className="form-control"
                placeholder="Doe"
                id="inputLastName"
              />
              <label htmlFor="inputEmail" className="fw-bold fs-6 mt-3 mb-2">
                Email
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="example@mail.com"
                id="inputEmail"
                pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
              />
              <label htmlFor="inputUsername" className="fw-bold fs-6 mt-3 mb-2">
                Nombre de usuario
              </label>
              <input
                name="username"
                type="text"
                className="form-control"
                placeholder="username"
                id="inputUsername"
                pattern="^[a-zA-Z0-9.\-_$@*!]{3,30}$"
              />

              <label htmlFor="inputaddress" className="fw-bold fs-6 mt-3 mb-2">
                Dirección
              </label>
              <input name="address" type="text" className="form-control" id="address" />

              <label htmlFor="inputphone" className="fw-bold fs-6 mt-3 mb-2">
                Teléfono
              </label>
              <input name="phone" type="number" className="form-control" id="inputphone" />

              <label htmlFor="inputPassword" className="fw-bold fs-6 mt-3 mb-2">
                Contraseña
              </label>
              <input
                name="password"
                type="password"
                className="form-control"
                placeholder="password"
                id="inputPassword"
                pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
              />

              <div className="d-flex mt-3 justify-content-end">
                <button type="submit" className="btn btn-success">
                  Agregar
                </button>

                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={() => setModalAgregar(false)}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default AdminUsuarios;
